module.exports = __webpack_public_path__ + "static/nine-pints-1b4cd155c4c85e333a63da10a9d9126b.jpg";